import React, { useEffect } from "react";
import { Footer } from "../../Components/Footer/Footer";
import { Header } from "../../Components/Header/Header";
import { PageHeader } from "../../Components/PageHeader/PageHeader";
import { useApp } from "../../context/AppContextProvider";
import { enviroment } from "../../enviroment";
import SeoDefault from "../../Components/Seo/SeoDefault";
import SidebarContentLayout from "../../Components/SidebarContentLayout/SidebarContentLayout";

export const Return = () => {
  const appData = useApp();
  let windowWidth = appData.appData.windowWidth;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const returnPolicyContent = {
    title: "Return and Refund Policy",
    effectiveDate: "February 29, 2024",
    sections: [
      {
        id: "cancellation-window",
        title: "Cancellation Window",
        content: [
          "<p>We offer a 7-day cancellation policy for all purchases made online or in-store. You must request a cancellation within 7 days from the date of purchase.</p>"
        ]
      },
      {
        id: "eligibility-criteria",
        title: "Eligibility Criteria",
        content: [
          "<h5>Full Refund:</h5>",
          "<p>Products must be unused, unopened, and returned in their original packaging with all tags attached.</p>",

          "<h5>Opened Items:</h5>",
          "<p>May be eligible for store credit or exchange at the sole discretion of Ashi Electronics.</p>",

          "<h5>Not Eligible for Cancellation:</h5>",
          "<ul>",
          "<li>Items marked as \"Final Sale\" or \"Clearance\"</li>",
          "<li>Products not returned in accordance with our policy</li>",
          "</ul>"
        ]
      },
      {
        id: "how-to-cancel",
        title: "How to Cancel",
        content: [
          "<h5>For Online Orders:</h5>",
          "<p>Email us at <a href='mailto:hello@ashielectronics.com'>hello@ashielectronics.com</a> within the 7-day window.</p>",

          "<p>Mention:</p>",
          "<ul>",
          "<li>Your Order Number</li>",
          "<li>The items you wish to cancel</li>",
          "<li>The reason for cancellation</li>",
          "</ul>",
          "<p>Our team will respond with return instructions.</p>",

          "<h5>For In-Store Purchases:</h5>",
          "<p>Bring the item(s) along with your purchase receipt to the following address within 7 days:</p>",
          "<p>Shop No. 4, Kaushik Complex,<br>",
          "Sector-17, Near PNB Bank, Sukhrali,<br>",
          "Gurgaon, Haryana – 122001, India</p>"
        ]
      },
      {
        id: "shipping-pickup",
        title: "Return Shipping & Pickup",
        content: [
          "<p>For online orders, we offer free pickup from the delivery address.</p>",
          "<p>For all returns, customers are responsible for the shipping costs unless otherwise specified.</p>"
        ]
      },
      {
        id: "refund-policy",
        title: "Refund Policy",
        content: [
          "<p>Refunds will be processed within 7 business days after we receive and verify the returned item(s).</p>",
          "<p>Refunds will be made to the original method of payment.</p>",
          "<p>For in-store purchases, the refund will be issued via the same payment method used at the time of purchase.</p>"
        ]
      },
      {
        id: "important-notes",
        title: "Important Notes",
        content: [
          "<p>This policy is applicable only to purchases made directly from Ashi Electronics.</p>",
          "<p>Products bought from third-party sellers or platforms are not covered under this policy.</p>",
          "<p>We reserve the right to refuse any return or exchange if the item does not meet our return conditions.</p>"
        ]
      },
      {
        id: "need-help",
        title: "Need Help?",
        content: [
          "<p>If you have any questions or need assistance, feel free to reach out:</p>",
          "<p>📧 Email: <a href='mailto:hello@ashielectronics.com'>hello@ashielectronics.com</a><br>",
          "📱 Phone: +91 96545 02991</p>"
        ]
      }
    ]
  };

  return (
    <React.Fragment>
      <SeoDefault
        title={`Return Policy - ${enviroment.BUSINESS_NAME}`}
        description={`Learn about ${enviroment.BUSINESS_NAME}'s return policy for easy returns on products.`}
        keywords={`${enviroment.BUSINESS_NAME} return policy, returns, electronics, appliances, buy online`}
        canonicalUrl={`${process.env.REACT_APP_URL}/return-policy`}
        pageType="website"
        breadcrumbItems={[
          { name: "Home", url: `${process.env.REACT_APP_URL}/` },
          { name: "Return Policy", url: `${process.env.REACT_APP_URL}/return-policy` },
        ]}
      />
      {windowWidth === "mobile" ? (
        <PageHeader title="Return Policy" hide={true} />
      ) : (
        <Header />
      )}
      <section className="section col-md-12">
        <div className="container">
          <SidebarContentLayout contentData={returnPolicyContent} />
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
};
